import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, watch, defineProps, defineEmits } from "../../../../adapter-vue";
import TUIChatEngine from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import loading from "../../../../assets/icon/loading.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["resendMessage"],
  setup(__props, { emit: emits }) {

const props = __props




const message = ref();
const TYPES = ref(TUIChatEngine.TYPES);
watchEffect(() => {
  message.value = props.messageItem;
});

const resendMessage = () => {
  emits("resendMessage");
};

return { __sfc: true,emits, props, message, TYPES, resendMessage, Icon, loading }
}

})